import Blue from "~/core";

new Blue({
  name: 'Search Bar',
  selector: ".site-search",
  setup(search) {
    if (search != null) {
      const searchField = search.querySelector("#search-text");
      const searchButton = search.querySelector("#search-button");

      searchField.addEventListener("keyup", function (e) {
        if (e.key === "Enter") {
          if (searchField.value.length > 0) {
            window.location.replace(`/search-results?query=${searchField.value}`);
          }
        }
      });

      searchButton.addEventListener("click", function () {
        if (searchField.value.length > 0) {
          window.location.replace(`/search-results?query=${searchField.value}`);
        }
      });
    }
  }
});